import { DASH, HASHTAG } from '../../commons/constants/constants'
import { TENANT_REFERRAL_TITLES } from './friend-referral/constants'

type WordsForPoints = {
  long: string
  short: string
}

export const handleValidationErrors = (
  validation: CommonValidationResponse,
  setErrors: (errors: Record<string, string>) => void
): void => {
  const validationErrors: Record<string, string> = {}
  validation.result.errors?.forEach((err) => {
    validationErrors[err.path] = err.message
  })
  setErrors(validationErrors)
}

export const removeHashtag = (value: string) => {
  return value ? value.replace(HASHTAG, '') : ''
}

export const transformWordsForPoints = (words: string): string => {
  if (!words) return ''

  return Object.entries(JSON.parse(words))
    .map(([key, val]) => `${key}: ${val}`)
    .join('\n')
}

export const getSeparatedWordsForPoints = (words: string): WordsForPoints => {
  if (!words) return { long: '', short: '' }

  const parsed = JSON.parse(words)
  const { long, short } = parsed
  return { long, short }
}

export const getRequiredAction = (config: TenantReferralCampaign): string => {
  const actions = [
    config.IsRequireCampaign && TENANT_REFERRAL_TITLES.EARN_CAMPAIGN,
    config.IsRequireOffer && TENANT_REFERRAL_TITLES.REDEEM_OFFER,
    config.IsRequireVerifyPhoneNumber && TENANT_REFERRAL_TITLES.VERIFY_PHONE
  ].filter(Boolean)

  return actions.length > 0 ? actions.join(', ') : DASH
}

export const resolveTenantSection = <T extends string>(
  section: string | undefined,
  validSections: readonly T[],
  defaultSection: T
): T => {
  if (section && validSections.includes(section as T)) {
    return section as T
  }

  return defaultSection
}

export const getTenantTabEditHref = (
  activeTab: number,
  tabToPathMap: Record<number, string>,
  defaultTab: number
): string => {
  return tabToPathMap[activeTab] ?? tabToPathMap[defaultTab] ?? ''
}
